import * as React from "react";
import {cx}       from "emotion";

import "./more-menu.scss";

import {ComponentLink,
        makeChain}     from "@Common/react/cst2";
import {UseState}      from "@Common/react/use-state";
import {Types}         from "@Common/types";


export const MoreMenu = ({
    items,
}:{
    items ?: Types.Common.UiComponents.PhotoDashboard.Models.MoreMenuItem[],
}) => (

    makeChain<JSX.Element>()

    // set state vars
    .then("state", (_, next:ComponentLink<typeof UseState<{
        showingItems  : boolean,
    }>>) => UseState({
        defaultValue: {
            showingItems: false,
        },
        next
    }))

    // render the menu
    .then(({state}) => (
        <div className="more-menu-tr9 more-menu">
            {state.value.showingItems && <>
                <div className="screen" onClick={() => state.onChange({...state.value, showingItems: false})}/>
                <ul className="menu">
                    {items.map(item => (
                        <li key={"menu-item-"+item.label}
                            onClick={() => {
                                state.onChange({...state.value, showingItems: false});
                                item.onClick();
                            }}
                        >
                            <i className={cx("fa", item.iconClass)}/>
                            <span>{item.label}</span>
                        </li>
                    ))}
                </ul>
            </>}
            <button onClick={() => state.onChange({...state.value, showingItems: true})}>•••</button>
        </div>
    ))

    .run()

);
